import {IStepOption, MdMenuPlacement} from 'ngx-ui-tour-md-menu';
import {IAccountSetupData} from 'src/app/modules/employees/services/account-setup-wizard.service';

export enum TourAnchors {
  MENU_SETTING = 'menusetting',
  MENU_EMPLOYEES = 'menuemployees',
  SETTINGS_ADD_PROFESSION_BUTTON_PROFESIA = 'settings_add_profession_button_Profesia',
  FORM_OCCUPATION = 'form_occupation',

  SETTINGS_ADD_PROFESSION_BUTTON_PRACOVISKO = 'settings_add_profession_button_Pracovisko',
  ADD_EDIT_WORKPLACE_MODAL = 'add_edit_workplace_modal',

  TOCATEGORIZATION_KATEGORIZÁCIA = 'toCategorization_Kategorizácia',
  CATEGORIZATION_DATA_GRID = 'categorization_data_grid',
  CATEGORIZATION_DATA_GRID_ADD_BUTTON = 'categorization_data_grid_add_button',
  CATEGORIZATION_ADD_EDIT_MODAL = 'categorization_add_edit_modal',
  OCCUPATIONS_DATA_GRID = 'occupations_data_grid',
  OCCUPATION_CATEGORIZATION_DIALOG = 'occupation-categorization-dialog',

  EMPLOYEES_DATA_GRID_ADD_BUTTON = 'employees_data_grid_add_button',
  EMPLOYEES_ADD_EDIT_EMPLOYEE = 'employees_add_edit_employee',
  EMPLOYEES_ADD_EMPLOYEE_CONTRACT = 'employees_add_employee_contract',

  EMPLOYEES_DATA_GRID = 'employees_data_grid',

  EMPLOYEE_DETAIL_DIALOG1 = 'employee-detail-dialog1',
  EMPLOYEE_DETAIL_DIALOG2 = 'employee-detail-dialog2',
  EMPLOYEE_DETAIL_DIALOG3 = 'employee-detail-dialog3',
}

const EMPLOYEES_PLACEMENT: MdMenuPlacement = {
  horizontal: true,
  xPosition: 'before',
  yPosition: 'below'
};

const DIALOG_PLACEMENT: MdMenuPlacement = {
  horizontal: true,
  xPosition: 'after',
  yPosition: 'below'
};

const DIALOG_PLACEMENT2: MdMenuPlacement = {
  horizontal: true,
  xPosition: 'after',
  yPosition: 'below'
};

const STEP_SETTINGS: IStepOption =
  {
    stepId: 'apt0',
    allowUserInitiatedNavigation: true,
    anchorId: TourAnchors.MENU_SETTING,
    nextOnAnchorClick: true,
    title: 'Hlavné menu',
    content: 'Kliknite v hlavnom menu na položku "Nastavenia", ktorá zobrazí nastavenia aplikácie.',
  };

const STEP_EMPLOYEES: IStepOption =
  {
    stepId: 'apt0',
    allowUserInitiatedNavigation: true,
    anchorId: TourAnchors.MENU_EMPLOYEES,
    nextOnAnchorClick: true,
    placement: EMPLOYEES_PLACEMENT,
    title: 'Hlavné menu',
    content: 'Kliknite v hlavnom menu na položku "Zamestnanci", ktorá zobrazí zoznam všetkých zamestnancov daného zamestnávateľa.',
  };

export const ASYNC_STEP_TIMEOUT = 1500;

const TOUR_ADD_PROFESSION: IStepOption[] = [
  {
    stepId: 'apt1-0',
    anchorId: 'account_setup_tab_1',
    title: 'Pridanie profesie',
    content: 'Profesia predstavuje typ pracovného pomeru zamestnanca, na ktorú sa viažu medicínske spôsobilosti. Na priradenie profesie zamestnancovi je potrebné vytvoriť profesiu.',
    nextBtnTitle: 'Pokračovať',
    nextOnAnchorClick: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  STEP_SETTINGS,
  {
    stepId: 'apt1-1',
    anchorId: TourAnchors.SETTINGS_ADD_PROFESSION_BUTTON_PROFESIA,
    title: 'Pridajte profesiu',
    content: 'Kliknite na tlačítko "Pridať profesiu" a vyplňte údaje.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt1-2',
    anchorId: TourAnchors.FORM_OCCUPATION,
    title: 'Profesia',
    content: 'Na vytvorenie profesie zadajte názov profesie a potvrďte stačením tlačitla \'Pridať profesiu\' .',
    placement: DIALOG_PLACEMENT
  }
];

const TOUR_ADD_WORKPLACE: IStepOption[] = [
  {
    stepId: 'apt2-0',
    anchorId: 'account_setup_tab_2',
    title: 'Pridanie pracoviska',
    content: 'Pracovisko predstavuje miesto výkonu práce zamestnancov. K pracovnému pomeru a priradeniu zamestnancov je potrebné najskôr vytvoriť pracovisko s jeho názvom, číslom a adresou.',
    nextBtnTitle: 'Pokračovať',
    nextOnAnchorClick: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  STEP_SETTINGS,
  {
    stepId: 'apt2-1',
    anchorId: TourAnchors.SETTINGS_ADD_PROFESSION_BUTTON_PRACOVISKO,
    title: 'Pridajte pracovisko',
    content: 'Kliknite na tlačítko "Pridať pracovisko" a vyplňte údaje.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt2-2',
    anchorId: TourAnchors.ADD_EDIT_WORKPLACE_MODAL,
    title: 'Pracovisko',
    content: 'Zadajte názov pracoviska, číslo pracoviska a adresu, kde sa pracovisko nachádza.',
    placement: DIALOG_PLACEMENT,
  },
];

const TOUR_ADD_CATEGORIZATION: IStepOption[] = [
  {
    stepId: 'apt3-0',
    anchorId: 'account_setup_tab_3',
    title: 'Pridanie kategorizácie',
    content: 'Kategorizácia predstavuje zaradenie pracovísk a profesií zamestnancov podľa miery zdravotných rizík. Každé pracovisko alebo profesia musí mať priradenú kategorizáciu, ktorá určuje podmienky pracovného prostredia a povinné lekárske prehliadky.',
    nextBtnTitle: 'Pokračovať',
    nextOnAnchorClick: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  STEP_SETTINGS,
  {
    stepId: 'apt3-1',
    anchorId: TourAnchors.TOCATEGORIZATION_KATEGORIZÁCIA,
    title: 'Kategorizácie',
    content: 'Kliknite na tlačítko "Zoznam kategorizácií" sa zobrazí okno so zoznamom, kde sa nachádza tlačítko pre pridanie novej kategórie.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  {
    stepId: 'apt3-2',
    anchorId: TourAnchors.CATEGORIZATION_DATA_GRID_ADD_BUTTON,
    title: 'Nová kategorizácia',
    content: 'Kliknite na tlačítko "Pridať kategorizáciu" a vyplňte údaje.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  {
    stepId: 'apt3-3',
    anchorId: TourAnchors.CATEGORIZATION_ADD_EDIT_MODAL,
    title: 'Kategória',
    content: 'Vyberte zamestnávateľa a zadajte: číslo kategorizácie, dátum odkedy platí kategorizácia a prípadne dokedy platí kategorizácia. Všetky polia, okrem dátumu dokedy platí kategorizácia sú poovinné zadať.',
    placement: DIALOG_PLACEMENT,
    allowUserInitiatedNavigation: true,
    nextOnAnchorClick: false,
  },
  {
    stepId: 'apt3-5',
    anchorId: TourAnchors.CATEGORIZATION_DATA_GRID,
    title: 'Zoznam kategorizácií',
    content: 'Kliknite na riadok zoznamu kategorizácií, pre výber kategorizácie.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  {
    stepId: 'apt3-6',
    anchorId: TourAnchors.OCCUPATIONS_DATA_GRID,
    title: 'Zoznam profesií',
    content: 'Kliknite na riadok zoznamu prosesií, pre výber konkrétnej profesie.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  {
    stepId: 'apt3-7',
    anchorId: TourAnchors.OCCUPATION_CATEGORIZATION_DIALOG,
    title: 'Nastavenie profesie',
    content: 'Zadajte, či je profesia aktívna a periodická, nastavte rizikové faktory, pracovné činnosti a školenia.',
    placement: DIALOG_PLACEMENT,
    allowUserInitiatedNavigation: true,
  },

];

const TOUR_ADD_EMPLOYEES: IStepOption[] = [
  {
    stepId: 'apt4-0',
    anchorId: 'account_setup_tab_4',
    title: 'Pridanie zamestanca',
    content: 'Zamestnanec predstavuje osobu pracujúcu pre zamestnávateľa, ku ktorej sa viažu údaje o pracovnom pomere, zmluvách a lekárskych spôsobilostiach. Pred priradením profesie a vytvorením kontraktu je potrebné zamestnanca najskôr pridať do systému so všetkými základnými údajmi.',
    nextBtnTitle: 'Pokračovať',
    nextOnAnchorClick: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  STEP_EMPLOYEES,
  {
    stepId: 'apt4-1',
    anchorId: TourAnchors.EMPLOYEES_DATA_GRID_ADD_BUTTON,
    title: 'Nový zamestnanec',
    content: 'Kliknite na tlačítko "Pridať zamestnanca" a vyplňte údaje.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt4-2',
    anchorId: TourAnchors.EMPLOYEES_ADD_EDIT_EMPLOYEE,
    title: 'Pridať zamestnanca',
    content: 'Zadajte údaje o zamestnancovi: Meno, Priezvisko, Dátum narodenia, Rodné číslo, E-mailová adresa, Telefónne číslo, Trvalý pobyt - Adresa.',
    placement: DIALOG_PLACEMENT
  },
  {
    stepId: 'apt4-3',
    anchorId: TourAnchors.EMPLOYEES_ADD_EMPLOYEE_CONTRACT,
    title: 'Kontrakt',
    isAsync: true,
    asyncStepTimeout: 1000,
    content: 'Zadajte údaje pre kontrakt zamestnanca.',
    placement: DIALOG_PLACEMENT,
  },

];

export const EmployeeGridSelectStep = 'apt5-1';

const TOUR_ADD_ORDERS: IStepOption[] = [
  {
    stepId: 'apt5-0',
    anchorId: 'account_setup_tab_5',
    title: 'Pridanie objednávky',
    content: 'Objednávka predstavuje požiadavku zamestnávateľa na vykonanie lekárskych prehliadok pre vybraných zamestnancov podľa ich profesií a spôsobilostí. Pred vytvorením objednávky je potrebné vybrať zamestnanca, určiť spôsobilosti a doplniť údaje potrebné k vystaveniu žiadosti.',
    nextBtnTitle: 'Pokračovať',
    nextOnAnchorClick: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
    allowUserInitiatedNavigation: true,
  },
  STEP_EMPLOYEES,
  {
    stepId: EmployeeGridSelectStep,
    anchorId: TourAnchors.EMPLOYEES_DATA_GRID,
    title: 'Zoznam zamestnancov',
    content: 'Kliknite na riadok zoznamu zamestnancov, pre výber zamestnanca.',
    nextOnAnchorClick: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt5-2',
    anchorId: TourAnchors.EMPLOYEE_DETAIL_DIALOG1,
    title: 'Spôsobilosti',
    content: 'Označte jednotlivé spôsobilosti, pre ktoré chcete vytvoriť objednávku prehliadky pracovníka.',
    placement: DIALOG_PLACEMENT2,
    enableBackdrop: false,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt5-3',
    anchorId: TourAnchors.EMPLOYEE_DETAIL_DIALOG2,
    title: 'Upresnenie objednávky',
    content: 'Upresnite údaje potrebné k vystaveniu objednávky.',
    placement: DIALOG_PLACEMENT2,
    enableBackdrop: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },
  {
    stepId: 'apt5-3',
    anchorId: TourAnchors.EMPLOYEE_DETAIL_DIALOG3,
    title: 'Objednávka bola vytvorená',
    content: 'Zatvorte okno dialógu pre vytváranie objednávky.',
    placement: {
      horizontal: true,
      xPosition: 'before',
      yPosition: 'below'
    },
    enableBackdrop: true,
    isAsync: true,
    asyncStepTimeout: ASYNC_STEP_TIMEOUT,
  },

];


export const TOUR_TABS: IAccountSetupData[] = [
  {id: '0', name: 'Tarifný plán'},
  {id: '1', tour: TOUR_ADD_PROFESSION, name: 'Pridať profesie'},
  {id: '2', tour: TOUR_ADD_WORKPLACE, name: 'Pridať pracoviská'},
  {id: '3', tour: TOUR_ADD_CATEGORIZATION, name: 'Nastaviť kategorizáciu'},
  {id: '4', tour: TOUR_ADD_EMPLOYEES, name: 'Pridať zamestnancov'},
  {id: '5', tour: TOUR_ADD_ORDERS, name: 'Prvá objednávka'}
];



